
import Vue from 'vue'
import VueResource from 'vue-resource'
import services from './services'
import interceptors from './interceptors'
import * as storage from '../modules/auth/storage'


Vue.use(VueResource)
const http = Vue.http

http.headers.common['Access-Control-Allow-Origin'] = '*'
http.headers.common['Content-Type'] = 'application/x-www-form-urlencoded;'
http.headers.common['Accept'] = 'application/json, text/plain, */*'
http.headers.common['Access-Control-Allow-Headers'] = 'Origin, Accept, Content-Type, Authorization, Access-Control-Allow-Origin'

// Permite enviar FormData (multipart) sem forcar x-www-form-urlencoded
http.interceptors.push(function(request, next){
    if (request && request.body && (typeof FormData !== 'undefined') && request.body instanceof FormData) {
        if (request.headers) {
            delete request.headers['Content-Type']
            delete request.headers['content-type']
        }
    }
    next()
});

http.options.root = process.env.VUE_APP_ROOT_API;
http.interceptors.push(interceptors);

Object.keys(services).map(service => {
    services[service] = Vue.resource('', {}, services[service])
})

const setBearerToken = (token) => {
    http.headers.common['Authorization'] = 'Bearer ' + token;
}

// Informa ao backend em qual tela (menu.to) o SPA está a cada requisição,
// pra que EnsureMenuAccessCompliance (services) possa checar se esse menu
// está bloqueado pro perfil do usuário agora — sem precisar de nenhum
// mapeamento manual rota-de-API↔menu no backend.
http.interceptors.push(function(request, next){
    // Mesmo padrão de acesso à rota atual usado em src/http/interceptors.js —
    // router.currentRoute não fica populado de forma confiável aqui,
    // .app._route é o que de fato reflete a rota ativa nesta versão.
    const to = window._Vue?.$router?.app?._route?.path
    if (to && request.headers) {
        // request.headers já é uma instância de Headers (vue-resource) nesse
        // ponto — atribuição via colchetes só cria uma propriedade solta no
        // objeto, ignorada ao montar os headers reais. Precisa usar .set().
        if (typeof request.headers.set === 'function') {
            request.headers.set('X-Menu-To', to)
        } else {
            request.headers['X-Menu-To'] = to
        }
    }
    next();
});


export default services
export { http, setBearerToken }



